import React from 'react';
import PropTypes from 'prop-types';
import { cx } from 'cvb';
import { ProPricesStyles } from './ProPrice.style';

const Price = ({ proPrice, getPrice, getUnitPrice, mode }) => {
  const prices = proPrice?.prices[0];

  return (
    <div>
      {prices?.unitPrice ? (
        <p className="pro-price">
          <span className={cx('unit-pro-price', mode)}>
            {getUnitPrice(prices?.unitPrice, prices?.symbol)} <span className="divider">|</span>{' '}
          </span>
          {getPrice(prices?.price, prices?.symbol)} {prices?.unitPrice ? prices?.unitPrice?.unitForSale : 'und'}
        </p>
      ) : (
        <p className={cx('pro-price-no-unit', mode)}>
          {getPrice(proPrice?.prices[0]?.price, proPrice?.prices[0]?.symbol)} und
        </p>
      )}
      <style jsx>{ProPricesStyles}</style>
    </div>
  );
};

Price.defaultProps = {
  getPrice: () => {},
  proPrice: {},
  getUnitPrice: () => {},
  mode: 'PDP_MAIN',
};

Price.propTypes = {
  getPrice: PropTypes.func,
  proPrice: PropTypes.object,
  getUnitPrice: PropTypes.func,
  mode: PropTypes.string,
};

export default Price;
